import { MediaConstraints } from '@wui/jssip/lib/RTCSession'

const SDP_CHANNEL_BUNDLE_STATUS_REGEX = /m=(?<channel>audio|video).*?\na=mid:(?<bundle>[0-2]).*?\n[a-z]=(?<status>sendrecv|recvonly|sendonly|inactive)/gsm

type SDPMediaConstraintsParsedType = {
  status: 'sendrecv' | 'recvonly' | 'sendonly' | 'inactive'
  channel: keyof MediaConstraints
  bundle: number
}

type SDPMessage = string

type SdpMediaDirection = 'sendrecv' | 'recvonly' | 'sendonly' | 'inactive'

const SDP_MEDIA_SECTION_REGEX = /\r?\nm=(audio|video)[^\r\n]*[\s\S]*?(?=\r?\nm=|$)/g

/** Направления media-секций audio/video */
export const getSdpMediaDirections = (sdp: SDPMessage): SdpMediaDirection[] => {
  const directions: SdpMediaDirection[] = []
  const regex = new RegExp(SDP_MEDIA_SECTION_REGEX.source, 'g')
  let match

  while ((match = regex.exec(sdp)) !== null) {
    const section = match[0]
    const directionMatches = [...section.matchAll(/\r?\na=(sendrecv|recvonly|sendonly|inactive)\s*/g)]
    const direction = directionMatches.at(-1)?.[1] ?? 'sendrecv'
    directions.push(direction as SdpMediaDirection)
  }

  return directions
}

/** Remote hold: все audio/video секции в SDP имеют sendonly или inactive (RFC 3264) */
export const isRemoteHoldFromSdp = (sdp: SDPMessage): boolean => {
  const directions = getSdpMediaDirections(sdp)
  if (!directions.length) {
    return false
  }

  return directions.every((direction) => direction === 'sendonly' || direction === 'inactive')
}

export const parseMediaConstraintsFromSDP = (sdp: SDPMessage): MediaConstraints => {
  const regex = new RegExp(SDP_CHANNEL_BUNDLE_STATUS_REGEX, 'gms')
  let m
  const result: MediaConstraints = {}
  while ((m = regex.exec(sdp)) !== null) {
    if (!m.groups) {
      throw new Error('Invalid INVITE SDP message')
    }

    const { status, channel } = m.groups as unknown as SDPMediaConstraintsParsedType
    // WUI-3347: Участник "отправляет" медиа если status === 'sendrecv' или 'sendonly'
    result[channel] = status === 'sendrecv' || status === 'sendonly'

    if (m.index === regex.lastIndex) {
      regex.lastIndex++
    }
  }

  return result
}
